module.exports = __webpack_public_path__ + "article-7051a3ee/delmaine-donson-4054103967b7420d1d417278ad371684.jpg";